'use strict';

require('jquery');

var _rwd = require('@fr/rwd');

/**
 * The extender plugin is used to show elements gradually one-by-one by clicking a button.
 * It expects the elements to be shown have an "extender-element"-class and the button as a button tag element within the extender.
 *
 * There are these configuration possibilities as data attributes on the extender:
 * data-initial-rows........count of rows to be initially displayed.
 * data-next-row-count......count of rows to be fetched. If not provided, the plugin will always fetch one more row.
 * data-xs-col..............count of columns on xs.
 * data-sm-col..............count of columns on sm.
 * data-md-col..............count of coluns on md.
 * data-lg-col..............count of coluns on lg.
 *
 * e.g.
 *
 * <div class="extender" data-initial-rows="1" data-xs-col="1"  data-sm-col2="2" data-md-col="3">
 *   <div class="extender-element">XXX</div>
 *   <div class="extender-element">YYY</div>
 *   <div class="extender-element">ZZZ</div>
 *   <button>Next Element</button>
 * </div>
 * .
 */
var extender = {

  /**
   * Initializes the extender plugin.
   * @param  {Object} jQuery The extender element.
   */
  init: function init() {

    // It uses the jquery boilerplate to build the plugin.
    // https://github.com/jquery-boilerplate/jquery-boilerplate
    //
    // Scroll down to the Plugin init method to get to the business logic.
    //
    // It is then made possible to fire the plugin on an DOM element like this:
    // $(yourElementSelector).extender();

    ;(function ($, window, document, undefined) {

      // Create the defaults once
      var pluginName = "extender",
          defaults = {};

      // The actual plugin constructor
      function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
      }

      // Avoid Plugin.prototype conflicts
      $.extend(Plugin.prototype, {

        init: function init() {

          var self = this;
          var $extender = $(this.element);
          var mQs = (0, _rwd.mediaQs)();

          $extender.addClass('hasExtender');

          var xs = $extender.attr('data-xs-col') || 1,
              sm = $extender.attr('data-sm-col') || 2,
              md = $extender.attr('data-md-col') || 3,
              lg = $extender.attr('data-lg-col') || 4;

          var countOfRowElements;

          if (mQs['until-xs']) {
            countOfRowElements = xs;
          } else if (mQs['until-sm']) {
            countOfRowElements = sm;
          } else if (mQs['until-md']) {
            countOfRowElements = md;
          } else if (mQs['until-lg']) {
            countOfRowElements = lg;
          }

          var initialRows = $extender.attr('data-initial-rows');
          if (!initialRows) initialRows = 2;

          $extender.find('.extender-element').slice(0, initialRows * countOfRowElements).attr('style', 'display: block;');
          $extender.find('.extender-element').slice(initialRows * countOfRowElements).addClass('is-hidden');

          $extender.find('.extender-button').on('click', function () {

            var $this = $(this);
            $extender = $this.closest('.hasExtender');

            var countOfRowElements;

            // Determine how many rows to display.
            if ($extender.attr('data-next-row-count')) {
              countOfRowElements = $extender.attr('data-next-row-count');
            } else {
              var xs = $extender.attr('data-xs-col') || 1,
                  sm = $extender.attr('data-sm-col') || 2,
                  md = $extender.attr('data-md-col') || 3,
                  lg = $extender.attr('data-lg-col') || 3;

              mQs = (0, _rwd.mediaQs)();

              if (mQs['until-xs']) {
                countOfRowElements = xs;
              } else if (mQs['until-sm']) {
                countOfRowElements = sm;
              } else if (mQs['until-md']) {
                countOfRowElements = md;
              } else if (mQs['until-lg']) {
                countOfRowElements = lg;
              }
              // Make sure it is a number, not a string.
              countOfRowElements = Number(countOfRowElements);

              // If there was a resizing of the window, fill up row if necessary.
              if ($extender.find('.extender-element:visible').length % countOfRowElements !== 0) {
                countOfRowElements = countOfRowElements + (countOfRowElements - $extender.find('.extender-element:visible').length % countOfRowElements);
              }
            }

            $extender.find('.extender-element:hidden').slice(0, countOfRowElements).removeClass('is-hidden');
            $extender.find('.extender-element:hidden').slice(0, countOfRowElements).slideToggle();
            // Hide button if all entries are showing.
            if ($extender.find('.extender-element:hidden').length === 0) {
              $this.hide();
            }
          });
        }

      });

      // A really lightweight plugin wrapper around the constructor,
      // preventing against multiple instantiations
      $.fn[pluginName] = function (options) {
        return this.each(function () {
          if (!$.data(this, "plugin_" + pluginName)) {
            $.data(this, "plugin_" + pluginName, new Plugin(this, options));
          }
        });
      };
    })(jQuery, window, document);
  }

};

$(function () {

  extender.init();
});